import React, { useEffect, useState } from "react";
import CDUSearchFilter from "model/utils/CDUSearchFilter";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Checkbox,
  Stack,
  Text,
  VariantColor,
} from "@noom/wax-component-library";

const selectableBusinessTypes = [
  CDUSearchFilter.businessTypeToValue.B2C,
  CDUSearchFilter.businessTypeToValue.B2B,
];

export type BusinessTypeModalProps = {
  isOpen: boolean;
  cduAccessCode: string;
  cduBusinessTypes?: string[];
  onSave: (cduAccessCode: string, businessTypes: string[]) => void;
  onDismiss: () => void;
};

export default function BusinessTypeModal({
  cduAccessCode,
  cduBusinessTypes,
  onSave,
  onDismiss,
  isOpen,
}: BusinessTypeModalProps) {
  const [selectedTypes, setSelectedTypes] = useState(cduBusinessTypes || []);

  useEffect(() => {
    setSelectedTypes(cduBusinessTypes || []);
  }, [cduAccessCode, cduBusinessTypes]);

  const handleCheckboxChange = (type: string): void => {
    setSelectedTypes((prev) =>
      prev.includes(type)
        ? prev.filter((t) => t !== type)
        : [...prev, type]
    );
  };

  const handleSave = (): void => {
    if (selectedTypes.length === 0) {
      return;
    }
    onSave(cduAccessCode, selectedTypes);
    onDismiss();
  };

  return (
    <Modal isOpen={isOpen} onClose={onDismiss} isCentered >
      <ModalOverlay />
      <ModalContent borderRadius="md" boxShadow="md" maxW="lg" className="Modal-box landlookGrid-box landlookSheet-box" >

        <ModalHeader>Select Business Types</ModalHeader>

        <ModalBody>
          <Stack align="start" spacing={4}>
            {selectableBusinessTypes.map((value) => (
              <Checkbox
                key={value}
                isChecked={selectedTypes.includes(value)}
                onChange={() => handleCheckboxChange(value)}
                borderWidth="1.5px"
                borderColor="gray.300"
              >
                {value}
              </Checkbox>
            ))}
          </Stack>
          <Text mt={4} color="red.500" fontSize="sm">
            At least one business type must be selected.
          </Text>
        </ModalBody>

        <ModalFooter>
          <Button
            onClick={handleSave}
            isDisabled={selectedTypes.length === 0}
            colorScheme={VariantColor.secondary}>
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
